import { useFormikContext } from "formik";
import React from "react";
import { SquareArrowOutUpRight } from "lucide-react";

const OutstandingBalanceInfo = ({
  transac = "purchase",
  badgeText = "",
  iconRequired = false,
  onClick = () => {},
  conClasss = "flex items-center justify-between gap-7 bg-[var(--out-standing-bg)] px-3 rounded-lg border border-[var(--out-standing-border)] shadow-sm h-[38px] cursor-pointer",
}) => {
  const { values } = useFormikContext();
  const creditBalance = values?.cmr_credit_balance || values?.cmr_balance;
  const isPositive = creditBalance >= 0;
  const isNegative = creditBalance < 0;
  return (
    <div onClick={onClick} className={conClasss}>
      {/* Left: Customer Info */}
      <div className="text-[length:var(--out-standing-font-size)] flex items-center gap-2 font-[var(--out-standing-font-fw)] text-[var(--out-standing-fg)] truncate">
        {transac !== "billing" && (
          <SquareArrowOutUpRight color="var(--out-standing-fg)" size={16} />
        )}

        {badgeText}
      </div>

      {/* Right: Balance Badge */}
      {(isPositive || isNegative) && (
        <div className="flex items-center gap-2">
          <span
            className={`whitespace-nowrap text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${
              isPositive
                ? "bg-[var(--pill-badge-green-bg)]"
                : "bg-[var(--pill-badge-red-bg)]"
            }`}
          >
            ₹ {Number(Math.abs(creditBalance)).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
      )}
    </div>
  );
};

export default OutstandingBalanceInfo;
